<!--
 * @Description: 支出记录详情
 * @Author: 琢磨先生
 * @Date: 2023-01-15 12:37:28
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2023-07-11 10:43:17
-->
<template>
  <el-dialog
    title="支出记录详情"
    v-model="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @closed="onClosed"
  >
    <div class="wrp" v-loading="loading">
      <el-descriptions :column="2">
        <el-descriptions-item label="费用项">{{model.expense_item_name}}</el-descriptions-item>
        <el-descriptions-item label="日期">{{model.pay_date}}</el-descriptions-item>
        <el-descriptions-item label="金额(元)">
          <b>￥{{model.decimal_total_amount}}</b>
        </el-descriptions-item>
        <el-descriptions-item label="成本(元)">￥{{model.decimal_cost_amount}}</el-descriptions-item>
        <el-descriptions-item label="单价(元)">{{model.decimal_unit_price}}{{model.expense_item_unit}}</el-descriptions-item>
        <el-descriptions-item label="数量">{{model.number}}</el-descriptions-item>
        <el-descriptions-item label="业主占比">
          <b>￥{{model.decimal_landlord_amount}}({{model.decimal_ratio}}%)</b>
        </el-descriptions-item>
        <el-descriptions-item label="商户占比">￥{{model.decimal_business_amount}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{model.remark}}</el-descriptions-item>
        <el-descriptions-item label="创建人">{{model.emp?.chs_name}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{model.create_at}}</el-descriptions-item>
      </el-descriptions>
      <el-divider>凭证</el-divider>
      <div class="image_preview">
        <el-image
          v-for="(item,i) in model.pic_urls"
          :key="item"
          :src="item"
          :initial-index="i"
          :preview-src-list="model.pic_urls"
        ></el-image>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      model: {},
    };
  },
  props: ["id"],
  emits: ["close"],
  watch: {
    id: {
      handler() {
        if (this.id) {
          this.dialogVisible = true;
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClosed() {
      this.$emit("close");
    },

    /**
     * 加载详情
     */
    loadData() {
      this.loading = true;
      this.$http
        .get("seller/v1/expense/record/dtl?id=" + this.id)
        .then((res) => {
          if (res.code == 0) {
            this.model = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style   scoped>
.wrp {
  min-height: 400px;
}
.image_preview {
  display: flex;
  flex-wrap: wrap;
  min-height: 100px;
}
.image_preview .el-image {
  margin-left: 15px;
  margin-bottom: 15px;
  border-radius: 5px;
  width: 100px;
  height: 100px;
}
.image_preview .el-image:first-child {
  margin-left: 0px;
}
</style>